import {defineStore} from 'pinia'
import axios, {AxiosResponse} from "axios";
import {costumersListUrl, inspectionsFrequenciesDetailsUrl, inspectionsFrequenciesListUrl} from "@/services/api";
import {IInterventionFrequency} from "@/types/intervention_frequency";
import {ICostumer} from "@/types/costumer";

export const useInterventionFrequencyStore = defineStore('interventionFrequencies', {
    state: () => ({
        loading: false as boolean,
        interventionFrequencies: [] as IInterventionFrequency[],
    }),
    persist: true,
    getters: {
        isLoading: (state) => state.loading,
        getInterventionFrequencies: (state) => state.interventionFrequencies,
        getInterventionFrequencyById: (state) => (id: number): IInterventionFrequency | undefined => state.interventionFrequencies.find(item => item.id == id),
    },
    actions: {
        async loadInspectionFrequencies() {
            this.loading = true;
            const response = await axios.get(inspectionsFrequenciesListUrl)
            if (response.status === 200) {
                this.$state.interventionFrequencies = response.data;
            }
            this.loading = false;
            return response;
        },
        async pushInspectionFrequencies(instance: IInterventionFrequency) {
            let response: AxiosResponse<any, any>;
            this.loading = true;
            if (instance.id) {
                response = await axios.put(inspectionsFrequenciesDetailsUrl(instance.id), instance);
            } else {
                response = await axios.post(inspectionsFrequenciesListUrl, instance);
            }
            if (response.status === 201) {
                await this.loadInspectionFrequencies()
            } else {
                this.loading = false;
                return response;
            }
        },
    },
});
